var m = require('mithril');
var modal = require('../../layout/components/modal');
var edit = require('../../layout/components/edit');
var addFeedsEdgeModal = require('../../equipment/components/addFeedsEdgeModal');
var equipmentCommentModal = require('../../equipment/components/equipmentCommentModal');
var propertiesViewerModal = require('../../equipment/components/equipmentPropertiesViewerModal');
var dragscroll = require('../../libs/dragscroll');
var rowActionDropdown = require('../../components/rowActionDropdown');
var equipmentModel = require('../../equipment/models/equipment');
var ontologyFields = require('../../../../../models/equipment/ontologyFields');

function getEquipmentRecord(vnode) {
  return typeof vnode.attrs.equipmentRecord === 'function'
    ? vnode.attrs.equipmentRecord()
    : vnode.attrs.equipmentRecord;
}

function renderFeedsPath(feedsPath, excludedRid) {
  if (!feedsPath || !feedsPath['@rid'] || !feedsPath.path || !feedsPath.path.length) return null;
  const nodes = feedsPath.path.filter(node => node && node['@rid'] && node['@rid'] !== excludedRid);
  if (!nodes.length) return null;

  return m('div.flex.items-start', [
    m('div', '•'),
    m('div.flex', { style: { flexWrap: 'nowrap' } }, nodes.map((node, idx) => (
      m('div.flex.items-end', [
        m(m.route.Link, {
          href: `/equipment/${node['@class'].toLowerCase()}/${node['@rid'].slice(1)}`,
          class: 'mh2'
        }, node.name || node['@class']),
        idx < nodes.length - 1 ? ' / ' : ''
      ])
    )))
  ]);
}

function renderFeedsPaths(feedsPaths, excludedRid) {
  if (!feedsPaths || !feedsPaths.length) return null;
  return m('div', feedsPaths.map((feedsPath) => renderFeedsPath(feedsPath, excludedRid)));
}

function renderPortBlock({ port, edges, equipmentRecord, isIncoming, vnode }) {
  return m('div.grid-item.pv1.ba.b--blue.overflow-hidden.mv2', {
    style: { minHeight: '46px' },
  },[
    m('div.dragscroll-container', [
      m(`div.dragscroll.mr4`, { oncreate: dragscroll }, [
        m(`div.bw1.pa2.flex.mb3${edit.vm.editing() ? '.justify-between' : ''}`, [
          m('div.mr2.nowrap', port.name),
          m('div.flex.flex-column',
            edges.map((edge) => {
              const target = isIncoming ? edge.out : edge.in;
              const targetRoute = target ? `/equipment/${target['@class'].toLowerCase()}/${target['@rid'].slice(1)}` : '#';

              return m('div.flex.items-start', { style: { whiteSpace: 'nowrap' } }, [
                m('div.blue.mr2.pointer', {
                  onclick: () => {
                    if (edit.vm.editing()) {
                      addFeedsEdgeModal.editDialogue(edge, equipmentRecord, port, {
                        submitCallback: vnode.attrs.submitCallback,
                        invertEquipment: isIncoming
                      });
                    } else if (target) {
                      m.route.set(targetRoute);
                    }
                  }
                }, `${target?.name || target?.['@class'] || ''}`),
                renderFeedsPaths(edge.feedsPaths, target && target['@rid'])
              ]);
            })
          ),
          (edit.vm.editing()
            ? m('i', {
              class: 'ion-plus blue pointer' + (edges.some(edge => edge.feedsPaths && edge.feedsPaths.length) ? ' ph2' : ''),
              onclick: () => addFeedsEdgeModal.editDialogue(
                undefined,
                equipmentRecord,
                port,
                {
                  submitCallback: vnode.attrs.submitCallback,
                  invertEquipment: isIncoming
                }
              )
            })
            : '')
        ])
      ])
    ])
  ]);
}


function renderConnectionsBody(equipmentRecord, vnode) {
  const ports = equipmentRecord.ports ? Object.values(equipmentRecord.ports) || [] : [];

  const incomingPorts = ports
    .filter(p => p.type == 'input')
    .filter(port => edit.vm.editing() || (equipmentRecord.in_Feeds || []).some(f => f.toPortId == port.id));

  const outgoingPorts = ports
    .filter(p => p.type == 'output')
    .filter(port => edit.vm.editing() || (equipmentRecord.out_Feeds || []).some(f => f.fromPortId == port.id));

  return m('div', [
    (edit.vm.editing() || incomingPorts.length) ? [
      m('div.pv1.tc.f4.w-100', 'Incoming'),
      m('div.w-100', incomingPorts.map(port => {
        const edges = (equipmentRecord.in_Feeds || []).filter(f => f.toPortId == port.id);
        return renderPortBlock({ port, edges, equipmentRecord, isIncoming: true, vnode });
      }))
    ] : null,
    (edit.vm.editing() || outgoingPorts.length) ? [
      m('div.pv1.tc.f4.w-100.mt3', 'Outgoing'),
      m('div.w-100', [
        outgoingPorts.map(port => {
          const edges = (equipmentRecord.out_Feeds || []).filter(f => f.fromPortId == port.id);
          return renderPortBlock({ port, edges, equipmentRecord, isIncoming: false, vnode });
        }),
      ])
    ] : null
  ]);
}

function openConnectionsModal(vnode) {
  const baseRecord = getEquipmentRecord(vnode);
  if (!baseRecord || !baseRecord['@rid']) return;

  const ridParam = baseRecord['@rid'].charAt(0) === '#'
    ? baseRecord['@rid'].slice(1)
    : baseRecord['@rid'];

  let loading = true;
  let error = null;
  let fullRecord = null;

  const renderBody = () => {
    if (loading) {
      return m('div.pa3.tc', [
        m('img.loading', { src: '/images/loading-bars.svg' })
      ]);
    }
    if (error) {
      return m('div.pa3.tc.red', error);
    }
    return renderConnectionsBody(fullRecord, vnode);
  };

  modal.vm.title(`Connections for ${baseRecord.name || baseRecord['@class']}`);
  modal.vm.body = renderBody;
  modal.vm.buttons([]);
  modal.vm.open({ extrawidth: true });

  m.request({
    method: 'GET',
    url: `/api/v1/equipment/${ridParam}`
  })
    .then((record) => {
      loading = false;
      fullRecord = record;
      modal.vm.title(`Connections for ${fullRecord.name || fullRecord['@class']}`);
      m.redraw();
    })
    .catch(() => {
      loading = false;
      error = 'Error loading connections. Please try again.';
      m.redraw();
    });
}

function buildMenuOptions(vnode, equipmentRecord, commentCount) {
  const options = [
    {
      key: 'connections',
      label: 'Connections',
      iconClass: 'ion-pull-request',
      action: () => openConnectionsModal(vnode)
    }
  ];
  const classData = equipmentModel.findClassData(equipmentRecord['@class']);
  const equipmentFields = ontologyFields.normalizeFieldDefinitions(classData && classData.data ? classData.data.fields : []);
  const hasDisplayableProperties = equipmentFields.some(function (field) {
    const resolved = ontologyFields.readEquipmentFieldValue(equipmentRecord, field);
    return ontologyFields.isDisplayableFieldValue(resolved.value, field);
  });

  if (!edit.vm.editing() && hasDisplayableProperties) {
    options.push({
      key: 'properties',
      label: 'Properties',
      iconClass: 'ion-ios-information-outline',
      action: () => propertiesViewerModal.editDialogue(equipmentRecord)
    });
  }

  if (!edit.vm.editing()) {
    options.push({
      key: 'comments',
      label: 'Comments',
      iconClass: 'ion-android-chat',
      badge: commentCount,
      action: () => equipmentCommentModal.open(equipmentRecord, { submitCallback: vnode.attrs.submitCallback, elementRid: vnode.attrs.elementRid })
    });
  }

  return options;
}

var smartTableLinksCell = {
  view: function (vnode) {
    const equipmentRecord = getEquipmentRecord(vnode) || {};
    const commentCount = typeof equipmentRecord.commentCount === 'number'
      ? equipmentRecord.commentCount
      : (Array.isArray(equipmentRecord.out_SubjectOf) ? equipmentRecord.out_SubjectOf.length : 0);
    const menuOptions = buildMenuOptions(vnode, equipmentRecord, commentCount);
    const dropdown = m(rowActionDropdown, {
      position: 'fixed',
      align: vnode.attrs.compact ? 'left' : undefined,
      buttonStyle: vnode.attrs.compact
        ? {
          minWidth: '1.6rem',
          paddingTop: '0.05rem',
          paddingBottom: '0.12rem',
          paddingLeft: '0.18rem',
          paddingRight: '0.18rem',
          lineHeight: '1'
        }
        : undefined,
      items: menuOptions.map(function (option) {
        return {
          label: typeof option.badge === 'number' ? `${option.label} (${option.badge})` : option.label,
          icon: option.iconClass,
          onclick: option.action
        };
      })
    });

    if (vnode.attrs.inline) {
      return m('div.flex.justify-end.items-center.relative', [
        dropdown
      ]);
    }

    return m('td.bb.bl-0.tc', { style: { width: 'auto' } }, [
      m('div.flex.justify-center.items-center.ph2.relative', [
        dropdown
      ])
    ]);
  }
};

module.exports = smartTableLinksCell;
